export enum OrderStatus {
  AWAITING_CONFIRMATION = "AWAITING_CONFIRMATION",
  ACCEPTED = "ACCEPTED",
  CANCELLED = "CANCELLED",
  PREPARING = "PREPARING",
  READY = "READY",
  COMPLETED = "COMPLETED",
}
